import React from 'react';

import { Box } from '@mui/material';

import { spaces } from '../../../../../assets/styles/themes/tokens';
import FeatureStatusChip from '../FeatureStatusChip';
import { MuiCardBaseProps } from '../MuiCardBase';
import useCardDimensions from '../../../../../utils/useCardDimensions';

const MuiCardBaseShortContainer: React.FC<{
  children: React.ReactNode;
  contentType: MuiCardBaseProps['contentType'];
  isNew: boolean;
  isTruncated: boolean;
}> = ({ children, contentType, isNew, isTruncated }) => {
  const cardDimensions = useCardDimensions();

  return (
    <Box
      tabIndex={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spaces.md,
        position: 'relative',
        minWidth: cardDimensions.mobile.minWidth,
        maxWidth: cardDimensions.mobile.maxWidth,
        border: '1px solid transparent',
        ...(isTruncated && { height: cardDimensions.short.height }),
      }}
      data-testid={`${contentType}-mui-card`}
    >
      {isNew && <FeatureStatusChip size='small' />}
      {children}
    </Box>
  );
};

export default MuiCardBaseShortContainer;
